// @file Vue composable for all loading state in Slideshow

import { useSlideshowStore } from '@@/pinia/slideshow'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'

export const useSlideshowLoadingState = (): {
  isDataLoaded: Ref<boolean>
  hasLoadedPages: Ref<boolean>
  isPageCoverLoaded: Ref<boolean>
  pageCoverLoaded: Ref<boolean>
} => {
  const { isDataLoaded, hasLoadedPages, isPageCoverLoaded, pageCoverLoaded } = storeToRefs(useSlideshowStore())

  return {
    isDataLoaded,
    hasLoadedPages,
    isPageCoverLoaded,
    pageCoverLoaded,
  }
}
